import React from 'react'
import Main from '../../../components/HOC/Main'
import BlogsForm from '../../../components/pages/BlogsForm'
import { NAVIGATION } from '../../../lib/navigation'
import { useLocation } from 'react-router-dom'

const EditBlogPage = () => {
    const location = useLocation();
    const { blogData } = location.state || {};
    return (
        <Main crumbs={[{ title: "blog" }, { title: "blogs", href: NAVIGATION.INNER_NAVIGATION.BLOGS.BLOGS }, { title: "update blog" }]}>
            <BlogsForm defaultData={blogData} />
        </Main>
    )
}

export default EditBlogPage